module.exports = __webpack_public_path__ + "media/images/mes_180_pup-138f82fc8622aa6a5cce3450c5f7be0f.png";